import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

interface NewMigrationLoginLinkRequest {
  contact: string;
  linkKey: string;
  signingMethod: string;
}

const convertToNewRequest = (request: {
  contactInfo: string;
  linkKey: string;
  signingMethodType: string;
}): NewMigrationLoginLinkRequest => {
  return {
    contact: request.contactInfo,
    linkKey: request.linkKey,
    signingMethod: request.signingMethodType,
  };
};

/**
 *
 * @deprecated Endpoint request is modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#0389653b55c0459dae8715c916bba841
 */
// eslint-disable-next-line import/prefer-default-export
export function fetchMigrationLoginLink({
  contactInfo,
  documentId,
  linkKey,
  participantId,
  signingMethodType,
}: {
  contactInfo: string;
  documentId: string;
  linkKey: string;
  participantId: string;
  signingMethodType: string;
}) {
  return requestApi<{ loginLink: string }>({
    url: withDocument(`/documents/${documentId}/participants/${participantId}/migration-access`),
    method: 'POST',
    credentials: false,
    data: convertToNewRequest({
      contactInfo,
      linkKey,
      signingMethodType,
    }),
  }).then((response) => response.data);
}
